export {
	DMS_MODULE, API_ND_AREA, API_ND_SKLAD,
} from '../constants';
export const NAME = 'NdSklad';
export const CRUMB_LABEL_LIST = 'grdNDAgendaSkladu';
export const CRUMB_LABEL_EDIT = 'edtNDSklad';
export const MENU_CODE = 'pAgendaSkladuND';

export const REFERENCE = 'Reference';
export const SHODA_KEY = 'ShodaNd';
export const NASLEDNICI_KEY = 'NahradyNasledovnici';
export const PREDCHUDCI_KEY = 'NahradyPredchudce';
export const POHYB_SKLAD = 'PohybSkladKarta';
export const POHYB_AUTOPRT = 'PohybAutopartObrat';
export const POHYB_MESICNI = 'PohybMesicniObrat';
export const PART_PRICING_LOG = 'PartPricingLog';
export const WEIGHTED_AVG = 'WeightedAverage';
export const Dealer = 'Dealer';
export const NdSklad = 'NdSklad';
export const BULK_ADJUSTMENT = 'Bulk Adjustment';

export const DEPENDENT_TABLES = <const>[
	SHODA_KEY,
	NASLEDNICI_KEY,
	PREDCHUDCI_KEY,
	POHYB_SKLAD,
	POHYB_AUTOPRT,
	POHYB_MESICNI,
	REFERENCE,
	PART_PRICING_LOG,
	WEIGHTED_AVG,
];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum SelectType {
	Both = 1,
	NdSklad = 2,
	NdCenik,
}

export enum AccessorTableEnum {
	Zakazka = 93,
	OZakazka = 213,
}

export enum TAB_NAMES {
	HLAVNI = 'Hlavni',
	DISPONIBILITA = 'Disponibilita',
	SPCDISPONIBILITA = 'SpcDisponibilita',
	SHODANAHRADAND = 'ShodaNahradaND',
	POZNAMKA = 'Poznamka',
	INVENTURA = 'Inventura',
	POHYBY = 'Pohyby',
	REFERENCE = 'Reference',
	NDP = 'NDP',
	WEIGHTEDAVG = 'WEIGHTEDAVG'
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'HlavniUdaje' },
	[TAB_NAMES.DISPONIBILITA]: { id: TAB_NAMES.DISPONIBILITA, labelKey: 'ndsklTab4' },
	[TAB_NAMES.SPCDISPONIBILITA]: { id: TAB_NAMES.SPCDISPONIBILITA, labelKey: 'ndsklTab6' },
	[TAB_NAMES.SHODANAHRADAND]: { id: TAB_NAMES.SHODANAHRADAND, labelKey: 'KD_NAME_NDNAHRADA' },
	[TAB_NAMES.POZNAMKA]: { id: TAB_NAMES.POZNAMKA, labelKey: 'ndsklTab1' },
	[TAB_NAMES.INVENTURA]: { id: TAB_NAMES.INVENTURA, labelKey: 'Inventura' },
	[TAB_NAMES.POHYBY]: { id: TAB_NAMES.POHYBY, labelKey: 'ndsklTab3' },
	[TAB_NAMES.REFERENCE]: { id: TAB_NAMES.REFERENCE, labelKey: 'HRefLink' },
	[TAB_NAMES.NDP]: { id: TAB_NAMES.NDP, labelKey: 'Pricing_Details' },
	[TAB_NAMES.WEIGHTEDAVG]: { id: TAB_NAMES.WEIGHTEDAVG, labelKey: 'Weighted_Average' },
};
